import { omit } from 'lodash';
import { ActivityType } from 'enums';
import { messages } from 'i18n';
import { ActivityLogList } from 'broker/pages/SubmissionWorkspacePage/components/Toolbox/components/ActivityLog';
import { useShareActivityLog } from 'broker/pages/SubmissionWorkspacePage/components/Toolbox/components/ActivityLog/useShareActivityLog';
import { submissionActivityTypeConfig } from 'broker/pages/SubmissionWorkspacePage/components/Toolbox/components/SubmissionActivity/submission-activity-type-config';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';

const carrierSubmissionActivityTypeConfig = omit(submissionActivityTypeConfig, [ActivityType.CustomerEmailReceived]);

export const CarrierSubmissionActivityLog = () => {
  const { activities } = useSubmissionsWorkspace();
  const { getShareOptions } = useShareActivityLog();

  return (
    <ActivityLogList
      activities={activities}
      activityTypeConfig={carrierSubmissionActivityTypeConfig}
      title={messages.submissionWorkspace.customerSection.submissionActivityLog}
      shareOptions={getShareOptions(activities)}
    />
  );
};
